import { ComposeViewState, TextDirection } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setExplicitTextDirection', function setExplicitTextDirection(
    viewState: ComposeViewState,
    textDirection: TextDirection
) {
    viewState.explicitTextDirection = textDirection;
});
